import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  const isActive = (path) => location.pathname === path;
  const isArabic = i18n.language?.startsWith('ar');
  const nextLang = isArabic ? 'en' : 'ar';

  return (
    <nav className="bg-charcoal-grey text-white shadow-lg">
      <div className="container mx-auto px-2 sm:px-4">
        <div className="flex items-center justify-between h-14 sm:h-16 gap-2 min-w-0">
          <Logo />

          <div className="flex items-center gap-1.5 sm:gap-4 md:gap-8 min-w-0">
            <Link
              to="/browse"
              className={`text-xs sm:text-base whitespace-nowrap hover:text-safety-yellow transition-colors ${
                isActive('/browse') ? 'text-safety-yellow' : ''
              }`}
            >
              {t('nav.browse')}
            </Link>
            <Link
              to="/list"
              className={`text-xs sm:text-base whitespace-nowrap hover:text-safety-yellow transition-colors ${
                isActive('/list') ? 'text-safety-yellow' : ''
              }`}
            >
              {t('nav.list')}
            </Link>
          </div>

          <button
            type="button"
            onClick={() => changeLanguage(nextLang)}
            className="flex-shrink-0 px-2.5 py-1 sm:px-3 text-xs sm:text-sm rounded bg-safety-yellow text-charcoal-grey font-semibold"
          >
            {nextLang === 'ar' ? 'AR' : 'EN'}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
